import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';
import { SessionService } from './session.service';
import { PlayerReportableMatchesResponse } from './player-matches-api.types';

@Injectable({ providedIn: 'root' })
export class PlayerMatchesApiService {
  private readonly http = inject(HttpClient);
  private readonly session = inject(SessionService);
  private readonly apiBaseUrl = environment.apiBaseUrl;

  getReportableMatches(): Observable<PlayerReportableMatchesResponse> {
    return this.http.get<PlayerReportableMatchesResponse>(
      `${this.apiBaseUrl}/api/players/me/reportable-matches`,
      { headers: this.authHeaders() }
    );
  }

  private authHeaders(): HttpHeaders {
    const token = this.session.token();
    return token ? new HttpHeaders({ Authorization: `Bearer ${token}` }) : new HttpHeaders();
  }
}
